import React from 'react'
import MultiSelect from '../../../../components/common/MultiSelect'
import PageHeading from '../../../../components/common/PageHeading'
import { guestfilterinboxby } from '../../../../data/guestcards'
import { Card, message, Form, Upload, Input, Space, Row, Col, Button } from 'antd'

import { DownloadOutlined, InboxOutlined } from '@ant-design/icons';

const { Dragger } = Upload;

const props = {
    name: 'file',
    multiple: true,
    action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    onChange(info) {
        const { status } = info.file;
        if (status !== 'uploading') {
            console.log(info.file, info.fileList);
        }
        if (status === 'done') {
            message.success(`${info.file.name} file uploaded successfully.`);
        } else if (status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
        }
    },
    onDrop(e) {
        console.log('Dropped files', e.dataTransfer.files);
    },
};


function BulkGuestCards() {
    return (
        <>

            <PageHeading heading="Bulk Guest Cards" />

            <div style={{ marginLeft: 4, marginBottom: 22 }}>
                <h4 style={{ fontSize: "1.1em", fontWeight: "500", marginBottom: 12 }}>Instructions for Uploading</h4>
                <p style={{ fontWeight: "200", marginBottom: 12, lineHeight: 1.5 }}>Your template includes your unique Property IDs, which are required for upload along with Email or Phone Number, Interest Received On Date, and Source.</p>
                <p style={{ fontWeight: "200", marginBottom: 12, lineHeight: 1.5 }}>For more information and examples go here.</p>
            </div>

            <Form
                name="basic"
                labelCol={{ span: 2 }}
                initialValues={{ remember: true }}
                autoComplete="off"
                className="form-container"
                colon={false}>

                <Row>
                    <Col span={24}>

                        <Card title="Select Properties and Download Template" >

                            <Form.Item
                                label="Properties"
                            >

                                <MultiSelect
                                    options={guestfilterinboxby}
                                    placeholder="Select..."
                                    className="filter-select"
                                    disabled={true}
                                />

                            </Form.Item>

                            <Form.Item
                                label=" "
                            >
                                <Button style={{ marginTop: 10 }} icon={<DownloadOutlined />}>Download Template</Button>
                            </Form.Item>

                        </Card>

                        <br />

                        <Card title="Upload Your Guest Cards" >

                            <Dragger {...props} style={{ padding: 8 }}>
                                <InboxOutlined />
                                <span style={{ marginLeft: 8, fontSize: "16px" }} >Drag files here or click to upload.</span>
                            </Dragger>
                        </Card>

                        <br />

                        <div className="form-action page-actions-container">
                            <Button type="primary" >Next</Button>
                            <Button >Cancel</Button>
                        </div>

                    </Col>
                </Row>
            </Form>
        </>
    )
}

export default BulkGuestCards